import { SocialShare as PageSocialShare } from '@web/components/page-components/SocialShare'
import { type SocialShare as SocialShareProps } from '@web/graphql-components'
import useShareableUrl from 'apps/fe-donation/libs/hooks/useShareableUrl'

const SocialShare = (
  props: SocialShareProps & { isFullWidth?: boolean; searchParams?: { [key in string]: string } },
) => {
  const shareableUrl = useShareableUrl(props)

  return <PageSocialShare {...props} url={shareableUrl} />
}

export default SocialShare
